import { render } from "./Menu.vue?vue&type=template&id=9bcc0be2&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=9bcc0be2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9bcc0be2"
/* hot reload */
if (module.hot) {
  script.__hmrId = "9bcc0be2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9bcc0be2', script)) {
    api.reload('9bcc0be2', script)
  }
  
  module.hot.accept("./Menu.vue?vue&type=template&id=9bcc0be2&scoped=true", () => {
    api.rerender('9bcc0be2', render)
  })

}

script.__file = "src/components/Menu.vue"

export default script